






























import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Translation from '@/components/i18n/Translation.vue';
import TranslationSource from '@/types/i18n/TranslationSource';
import FormField from '@/components/form/FormField.vue';
import { ValidationError } from 'class-validator';
import Button from '@/components/Button.vue';

@Component({
  components: { Translation, FormField, Button },
})
export default class ButtonToggleField extends Vue {
  @Prop(Array)
  public value!: string[];

  @Prop(String)
  public identifier!: string;

  @Prop(String)
  public label!: string;

  @Prop({ type: Boolean, default: true })
  public labelIsPath!: boolean;

  @Prop(Boolean)
  public hasInfo!: boolean;

  @Prop(Boolean)
  public isMandatory!: boolean;

  @Prop(Array)
  public values!: string[];

  @Prop(Object)
  public validationError!: ValidationError | null;

  @Emit()
  public infoClick(): void {}

  public toggle(val: string): void {
    if (!this.value) {
      this.$emit('input', [val]);
      return;
    }
    const valIndex = this.value.indexOf(val);
    if (valIndex === -1) {
      this.value.push(val);
    } else {
      this.value.splice(valIndex, 1);
    }
    this.$emit('input', this.value);
  }

  public isValueActive(val: string): boolean {
    if (!this.value) {
      return false;
    }
    return this.value.indexOf(val) > -1;
  }
}
